<template functional>
  <v-card class="elevation-0 text-align" :height="props.height">
    <v-card-text class="text-center texto-corrido" :style="{ maxWidth: `${props.width}px` }">
      <v-row justify="center" class="mb-5">
        <slot name="custom-content"></slot>
      </v-row>
      {{ props.message }}
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'EmptyCard',
}
</script>

<style scoped>
.text-align {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
